<div class="canvas-item">
	<ng-container *ngFor="let item of canvasSelected.menuItems">
		<p-button pRipple styleClass="p-button-raised p-button-secondary canvas-menu-item mx-1 my-2" (click)="selectItem(item)">
			<ng-template pTemplate="content">
				<div class="item-name">
					{{ item.ooMenuItem.name }}
				</div>
			</ng-template>
		</p-button>
	</ng-container>
</div>

<app-pos-item-modifier *ngIf="itemSelected && displayModifierDialog" [(itemSelected)]="itemSelected"></app-pos-item-modifier>
